import axios from '../axios'
export const getcount = (params) => {
  return axios({
    url: '/report/areadetail',
    method: 'get',
    params
  })
}
export const findVerifyPage = (data) => {
  return axios({
    url: '/weface/find/auth/record',
    method: 'post',
    data
  })
}
export const findByIdNo = (data) => {
  return axios({
    url: '/person/info',
    method: 'post',
    data
  })
}
export const findByIdCard = (data) => {
  return axios({
    url: '/findByIdCard',
    method: 'post',
    data
  })
}
//待审核
export const perVerifyList = (data) => {
  return axios({
    url: '/perVerifyList',
    method: 'post',
    data
  })
}
export const veriryCheck = (data) => {
  return axios({
    url: '/veriryCheck',
    method: 'post',
    data
  })
}
//修改信息
export const updateLib = (data) => {
  return axios({
    url: '/update/lib',
    method: 'post',
    data
  })
}
//新增
export const addLib = (data) => {
  return axios({
    url: '/add/lib',
    method: 'post',
    data
  })
}
//导出
export const authData = (data) => {
  return axios({
    url: '/down/auth/data',
    method: 'post',
    data
  })
}
//公安
export const police = (data) => {
  return axios({
    url: '/weface/compare/identity',
    method: 'post',
    data
  })
}
export const addauthrecord = (data) => {
  return axios({
    url: '/weface/add/auth/record',
    method: 'post',
    data
  })
}

//数统
export const chart = (data) => {
  return axios({
    url: '/weface/auth/chart',
    method: 'post',
    data
  })
}
//认证时间段
export const authLook = (data) => {
  return axios({
    url: '/weface/auth/time/look',
    method: 'post',
    data
  })
}
export const authAdd = (data) => {
  return axios({
    url: '/weface/auth/time/add',
    method: 'post',
    data
  })
}
export const authUpdate = (data) => {
  return axios({
    url: '/weface/auth/time/update',
    method: 'post',
    data
  })
}
//修改认证状态
export const updateState = (data) => {
  return axios({
    url: '/update/col/state',
    method: 'post',
    data
  })
}
//查看认证状态
export const stateLog = (data) => {
  return axios({
    url: '/col/state/log',
    method: 'post',
    data
  })
}
//操作日志记录
export const logQuery = (data) => {
  return axios({
    url: '/log/query',
    method: 'post',
    data
  })
}
//查询统计
export const queryMonth = (data) => {
  return axios({
    url: '/weface/query/auth/paygrant',
    method: 'post',
    data
  })
}


//查询登记待审核信息
export const listExamining = (data) => {
  return axios({
    url: '/examine/listExamining',
    method: 'post',
    data
  })
}

///查询登记已审核
export const listExamed = (data) => {
  return axios({
    url: '/examine/listExamed',
    method: 'post',
    data
  })
}

//查询登记审核进度
export const viewProgress = (params) => {
  return axios({
    url: '/examine/progressView',
    method: 'get',
    params
  })
}
//登记审核
export const examine = (data) => {
  return axios({
    url: '/examine/update',
    method: 'post',
    data
  })
}
//导出
export const toee = (data) => {
  return axios({
    url: '/down/auth/paygrantexport',
    method: 'post',
    data
  })
}
//认证记录
export const authRecord = (data) => {
  return axios({
    url: '/excel/addVeriryRecord',
    method: 'post',
    data
  })
}

//
export const selectflowState = (params) => {
  return axios({
    url: '/folw/selectflowState',
    method: 'get',
    params
  })
}



//新增流程
export const insertFolwCourse = (params) => {
  return axios({
    url: 'folw/insertFolwCourse',
    method: 'get',
    params
  })
}
//流程
export const selectflowlist = (data) => {
  return axios({
    url: '/folw/selectflowlist',
    method: 'post',
    data
  })
}
export const selectRoleName = (data) => {
  return axios({
    url: 'role/selectRoleName',
    method: 'post',
    data
  })
}
export const selectRoleremark = (params) => {
  return axios({
    url: '/folw/selectRoleremark2',
    method: 'get',
    params
  })
}
export const selectAnalyze = (data) => {
  return axios({
    url: '/weface/query/allAnalyze',
    method: 'post',
    data
  })
}
export const selectS = (data) => {
  return axios({
    url: '/weface/query/money/analyze',
    method: 'post',
    data
  })
}

//短信推送
export const authMessage = (data) => {
  return axios({
    url: '/weface/auth/message',
    method: 'post',
    data
  })
}
//daoling
export const ageMessage = (data) => {
  return axios({
    url: '/weface/age/message',
    method: 'post',
    data
  })
}

//推送记录
export const queryMessage = (data) => {
  return axios({
    url: '/weface/query/auth/message',
    method: 'post',
    data
  })
}
//记录详情
export const messageDetail = (data) => {
  return axios({
    url: '/weface/query/auth/message/detail',
    method: 'post',
    data
  })
}
//查询
export const authTel = (data) => {
  return axios({
    url: '/weface/no/auth/tel',
    method: 'post',
    data
  })
}
export const eightyTel = (data) => {
  return axios({
    url: '/weface/age/eighty/tel',
    method: 'post',
    data
  })
}
//跨档
export const crossUser = (data) => {
  return axios({
    url: '/weface/age/cross/user',
    method: 'post',
    data
  })
}
//跨档短信
export const crossMessage = (data) => {
  return axios({
    url: '/weface/age/cross/message',
    method: 'post',
    data
  })
}

export const chartOne = (data) => {
  return axios({
    url: '/chart/one',
    method: 'post',
    data
  })
}
export const chartTwo = (data) => {
  return axios({
    url: '/chart/two',
    method: 'post',
    data
  })
}
export const chartThree = (data) => {
  return axios({
    url: '/chart/three',
    method: 'post',
    data
  })
}

export const queryExcel = (data) => {
  return axios({
    url: 'weface/query/excelUpload',
    method: 'post',
    data
  })
}

//批量审核
export const updateBatch = (data) => {
  return axios({
    url: 'examine/updateBatch',
    method: 'post',
    data
  })
}

//新审核
export const authcheck = (data) => {
  return axios({
    url: 'weface/auth/check',
    method: 'post',
    data
  })
}
//年龄统计
export const chartAgecount = (data) => {
  return axios({
    url: 'chart/agecount',
    method: 'post',
    data
  })
}
//总数
export const chartAllcount = (data) => {
  return axios({
    url: 'chart/allcount',
    method: 'post',
    data
  })
}
//认证人数
export const chartAuthcount = (data) => {
  return axios({
    url: 'chart/authcount',
    method: 'post',
    data
  })
}//新增人数
export const chartInscrcount = (data) => {
  return axios({
    url: 'chart/inscrcount',
    method: 'post',
    data
  })
}
//类型人数
export const chartVerifytypecount = (data) => {
  return axios({
    url: 'chart/verifytypecount',
    method: 'post',
    data
  })
}
//核减人数
export const chartSubcount = (data) => {
  return axios({
    url: 'chart/subcount',
    method: 'post',
    data
  })
}
//redis
export const getInfos = (params) => {
  return axios({
    url: 'redis/get/infos',
    method: 'get',
    params
  })
}
//redis
export const redisupdate = (params) => {
  return axios({
    url: 'redis/update',
    method: 'get',
    params
  })
}
export const redisdelete = (params) => {
  return axios({
    url: 'redis/delete',
    method: 'get',
    params
  })
}
export const redisexport = (params) => {
  return axios({
    url: 'redis/export',
    method: 'get',
    params
  })
}
export const updateadrState = (params) => {
  return axios({
    url: 'update/adrState',
    method: 'get',
    params
  })
}
//修改银行卡号
export const updateBankNo = (data) => {
  return axios({
    url: 'update/bankNo',
    method: 'post',
    data
  })
}
//查询基本信息
export const queryPersonAll = (data) => {
  return axios({
    url: 'query/person/all',
    method: 'post',
    data
  })
}
//导出
export const downColData = (data) => {
  return axios({
    url: 'down/col/data',
    method: 'post',
    data
  })
}
//删除个人基础信息
export const delPersonInfo = (params) => {
  return axios({
    url: 'del/person/info',
    method: 'get',
    params
  })
}
//商城登记
export const retiress = (data) => {
  return axios({
    url: 'retiress/add/info',
    method: 'post',
    data
  })
}
//上传图片
export const etiress = (data) => {
  return axios({
    url: 'retiress/images/upload',
    method: 'post',
    data
  })
}
//聊城基础信息
export const baseinfo = (data) => {
  return axios({
    url: 'retiress/select/baseinfo',
    method: 'post',
    data
  })
}
//聊城详细信息
export const allinfo = (data) => {
  return axios({
    url: 'retiress/select/allinfo',
    method: 'post',
    data
  })
}

//识别银行名称
export const getBankNume = (params) => {
  return axios({
    url: 'get/bank/name',
    method: 'get',
    params
  })
}
//查询导出
export const exportbaseinfo = (data) => {
  return axios({
    url: 'retiress/export/baseinfo',
    method: 'post',
    data
  })
}
//档次查询
export const getGrades = (data) => {
  return axios({
    url: 'price/get/grades',
    method: 'post',
    data
  })
}
//认证率查询
export const getAuthRate = (data) => {
  return axios({
    url: 'chart/rate',
    method: 'post',
    data
  })
}
//认证率导出
export const exportAuthRate = (data) => {
  return axios({
    url: '/down/auth/rate',
    method: 'post',
    data
  })
}
//审核导出
export const recordPdfBatch = (data) => {
  return axios({
    url: '/examine/recordPdfBatch',
    method: 'post',
    data
  })
}
var urlList;
function getstatus() {
  if (sessionStorage.getItem("status") == "1") {
    urlList = ["/review/query/reviewwaring", "/review/query/reviewpush", "/review/query/reviewhis"]
  } else {
    urlList = ["social/review/query/reviewwaring", "social/review/query/reviewpush", "social/review/query/reviewhis"]

  }
  console.log(urlList)
}

//照片
export const reviewwaring = (data) => {
  getstatus()
  return axios({
    url: urlList[0],
    method: 'post',
    data
  })
}
//照片
export const reviewpush = (data) => {
  getstatus()
  return axios({
    url: urlList[1],
    method: 'post',
    data
  })
}
//历史
export const reviewhis = (data) => {
  getstatus()
  return axios({
    url: urlList[2],
    method: 'post',
    data
  })
}
export const updatetime = (data) => {
  return axios({
    url: '/update/adrRecordTime',
    method: 'post',
    data
  })
}





// WEBPACK FOOTER //
// ./src/http/moudules/getlist.js